import Vue from "vue";
import App from "./App.vue";
import store from "../../store";
import axios from "axios";
import VueAxios from "vue-axios";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(VueAxios, axios);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

Vue.prototype.$hostUrl = "https://stem2.science.swu.ac.th/";
new Vue({
    store,
    render: h => h(App)
}).$mount("#app");